/* tslint:disable */
/* eslint-disable */
/**
 * Umsatzcontrolling
 * Money
 *
 * The version of the OpenAPI document: 0.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * AORV-Import-Aenderung
 * @export
 * @interface AorvExcelZeile
 */
export interface AorvExcelZeile {
    /**
     * 
     * @type {number}
     * @memberof AorvExcelZeile
     */
    id: number;
    /**
     * Die Nummer des AORV-Auftrags.
     * @type {string}
     * @memberof AorvExcelZeile
     */
    auftragsNummer: string;
    /**
     * 
     * @type {string}
     * @memberof AorvExcelZeile
     */
    typ: AorvExcelZeileTypEnum;
    /**
     * Name der Maschinengruppe, für die die Änderung gilt.
     * @type {string}
     * @memberof AorvExcelZeile
     */
    maschinenGruppe: string;
    /**
     * Monat der Änderung.
     * @type {number}
     * @memberof AorvExcelZeile
     */
    monat: number;
    /**
     * 
     * @type {number}
     * @memberof AorvExcelZeile
     */
    kostenSchaetzung: number;
    /**
     * 
     * @type {number}
     * @memberof AorvExcelZeile
     */
    rechnungsBetrag?: number;
    /**
     * ID des zugehörigen Prognose-Umsatzdatensatzes.
     * @type {number}
     * @memberof AorvExcelZeile
     */
    umsatzIdPrognose: number;
    /**
     * ID des zugehörigen Berichts-Umsatzdatensatzes.
     * @type {number}
     * @memberof AorvExcelZeile
     */
    umsatzIdBericht?: number;
}


/**
 * @export
 */
export const AorvExcelZeileTypEnum = {
    Standard: 'STANDARD',
    Nebenfahrtenleiter: 'NEBENFAHRTENLEITER',
    Vermessung: 'VERMESSUNG'
} as const;
export type AorvExcelZeileTypEnum = typeof AorvExcelZeileTypEnum[keyof typeof AorvExcelZeileTypEnum];


/**
 * Check if a given object implements the AorvExcelZeile interface.
 */
export function instanceOfAorvExcelZeile(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;
    isInstance = isInstance && "auftragsNummer" in value;
    isInstance = isInstance && "typ" in value;
    isInstance = isInstance && "maschinenGruppe" in value;
    isInstance = isInstance && "monat" in value;
    isInstance = isInstance && "kostenSchaetzung" in value;
    isInstance = isInstance && "umsatzIdPrognose" in value;

    return isInstance;
}

export function AorvExcelZeileFromJSON(json: any): AorvExcelZeile {
    return AorvExcelZeileFromJSONTyped(json, false);
}

export function AorvExcelZeileFromJSONTyped(json: any, ignoreDiscriminator: boolean): AorvExcelZeile {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'auftragsNummer': json['auftragsNummer'],
        'typ': json['typ'],
        'maschinenGruppe': json['maschinenGruppe'],
        'monat': json['monat'],
        'kostenSchaetzung': json['kostenSchaetzung'],
        'rechnungsBetrag': !exists(json, 'rechnungsBetrag') ? undefined : json['rechnungsBetrag'],
        'umsatzIdPrognose': json['umsatzIdPrognose'],
        'umsatzIdBericht': !exists(json, 'umsatzIdBericht') ? undefined : json['umsatzIdBericht'],
    };
}

export function AorvExcelZeileToJSON(value?: AorvExcelZeile | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'auftragsNummer': value.auftragsNummer,
        'typ': value.typ,
        'maschinenGruppe': value.maschinenGruppe,
        'monat': value.monat,
        'kostenSchaetzung': value.kostenSchaetzung,
        'rechnungsBetrag': value.rechnungsBetrag,
        'umsatzIdPrognose': value.umsatzIdPrognose,
        'umsatzIdBericht': value.umsatzIdBericht,
    };
}

